export default "__VITE_ASSET__C8jmv5d5__"